import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  StudentGroup,
  StudentGroupMember,
} from '../../interfaces/student-group';
import {
  ApiCollectionResponse,
  ApiSingleResponse,
} from '../../interfaces/responses/api-response';

/**
 * Professor-side endpoints — read-only access scoped to the connected
 * professor's groups (auto-scoped via JWT, no professorId path param).
 */
@Injectable({ providedIn: 'root' })
export class ProfessorStudentGroupService {
  private readonly base = `${environment.BASE_URL}/professor/student-groups`;

  constructor(private http: HttpClient) {}

  /** Groups assigned to the connected professor. */
  myGroups(): Observable<ApiCollectionResponse<StudentGroup>> {
    return this.http.get<ApiCollectionResponse<StudentGroup>>(this.base);
  }

  getById(id: number): Observable<ApiSingleResponse<StudentGroup>> {
    return this.http.get<ApiSingleResponse<StudentGroup>>(`${this.base}/${id}`);
  }

  members(
    groupId: number,
  ): Observable<ApiCollectionResponse<StudentGroupMember>> {
    return this.http.get<ApiCollectionResponse<StudentGroupMember>>(
      `${this.base}/${groupId}/members`,
    );
  }

  byLevel(
    learningPathId: number,
  ): Observable<ApiCollectionResponse<StudentGroup>> {
    return this.http.get<ApiCollectionResponse<StudentGroup>>(
      `${this.base}/by-level/${learningPathId}`,
    );
  }
}
